export const environment = {
  production: true,
  API: "https://ibolthost.com.br:8080/biotech/",
  // API: "http://179.190.38.52:8080/biotech/",
};
